import { Alert, Table } from "antd"
import { Heading } from "../../../components/styled/Heading"
import { useEffect, useState } from "react"
import RESET_ALERT from "../../../constants/resetAlert"
import { useAppSelector } from "../../../redux/hooks"
import { errorTimeout } from "../../../constants/general"
import { useQuery } from "@apollo/client"
import { IAuditNote, IGetAuditNotesResponse } from "./types"
import { GET_AUDIT_NOTES } from "./graphql"
import { auditNotesColumns } from "./columns"

const Audit = () => {
  const pageSize = 5
  const [alert, setAlert] = useState(RESET_ALERT)

  const { selectedClaimId } = useAppSelector((state) => state.ui)

  const { data, loading } = useQuery<IGetAuditNotesResponse>(GET_AUDIT_NOTES, {
    variables: {
      claimId: selectedClaimId,
    },
    skip: !selectedClaimId,
    onError(error) {
      setAlert({
        type: "error",
        message: error.message,
      })
    },
  })

  useEffect(() => {
    const timer = setTimeout(() => {
      setAlert(RESET_ALERT)
    }, errorTimeout)

    return () => clearTimeout(timer)
  }, [alert])

  return (
    <div className="pt-5">
      <Heading heading="Audit Notes" />
      {alert.message && <Alert className="mb-3" {...alert} />}
      <Table<IAuditNote>
        key="_id"
        loading={loading}
        scroll={{ x: "max-content" }}
        columns={auditNotesColumns}
        dataSource={data?.notesByClaimId.auditLogs}
        pagination={{
          pageSize,
        }}
      />
    </div>
  )
}

export { Audit }
